import { Box, InputBase, useTheme } from '@mui/material';
import { GridRenderEditCellParams } from '@mui/x-data-grid';
import React, { useMemo } from 'react';

import { TInvalidRows } from '../../../../../types/addressBook';
import { StatusCell } from '../../components';

interface IProps {
  params: GridRenderEditCellParams;
  invalidRows: TInvalidRows;
}

const LabelEditCell: React.FC<IProps> = ({ params: { id, value, api, field }, invalidRows }) => {
  const theme = useTheme();

  const hasErrors = useMemo(() => invalidRows[id] && Object.keys(invalidRows[id]).length > 0, [invalidRows, id]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <StatusCell hasErrors={hasErrors} />
      <InputBase
        value={value as string}
        onChange={(e) =>
          api.setEditCellValue({
            id,
            field,
            value: e.target.value,
          })
        }
        autoFocus
        sx={{
          flexGrow: 1,
          height: '100%',
          paddingLeft: 1,
          typography: 'body2',
          borderBottom: `2px solid ${theme.palette.primary.main}`,
          '&.Mui-focused': {
            borderBottom: `2px solid ${theme.palette.primary.main}`,
          },
          '& .MuiInputBase-input': {
            height: '100%',
            boxSizing: 'border-box',
            paddingRight: theme.spacing(2),
          },
        }}
      />
    </Box>
  );
};

export default React.memo(LabelEditCell);
